import React, { useState, useEffect } from "react";
import Header from "./Header.js";
import { Pagination } from "react-bootstrap";
import {
  Calendar,
  ChevronDown,
  Edit,
  Filter,
  Plus,
  Search,
} from "lucide-react";
import Loader from "./Loader.js";
import update from "../assets/editBlack.svg";
import GreyArrow from "../assets/greyLeftAr.png";
import FilterIcon from "../assets/filterIcon.png";
import GuestIcon from "../assets/guestIcon.png";
import { Modal, Button } from "react-bootstrap";
import { GuestManagementPageText } from "../CommonJquery/WebsiteText.js";
import DatePicker from "react-datepicker"; // Import DatePicker
import "react-datepicker/dist/react-datepicker.css"; // Import DatePicker CSS
import {
  server_post_data,
  restaurant_subscriptions,
  save_restaurant_subs,
} from "../ServiceConnection/serviceconnection.js";
import {
  handleError,
  computeTodayDate,
  handleIaphabetnumberChange,
  computeplussevendays,
  combiled_form_data,
  handleNumbersChange,
  handleSuccess,
} from "../CommonJquery/CommonJquery.js";
import Select from "react-select";

// import React, { useEffect, useState } from "react";
// import Select from "react-select";
// import { Modal, Button } from "react-bootstrap";

function SubscriptionManagement() {
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [editStaffData, seteditStaffData] = useState([]);
  const [filterOption, setFilterOption] = useState("");
  // Convert string dates to Date objects for DatePicker
  const convertToDate = (dateString) => {
    if (!dateString) return new Date();
    const [year, month, day] = dateString.split("-").map(Number);
    return new Date(year, month - 1, day);
  };

  // Set initial state using useState hook with Date objects
  const [startDate, setStartDate] = useState(
    convertToDate(computeplussevendays())
  );
  const [endDate, setEndDate] = useState(convertToDate(computeTodayDate()));
  const [selectedOption, setSelectedOption] = useState("Name");
  const [searchText, setSearchText] = useState("");
  // const [SelectedData, setSelectedData] = useState([]);
  const [searchfilter, setSearchFilter] = useState("");
  const [filteredData, setfilteredData] = useState([]);
  const [selectedValue, setSelectedValue] = useState(""); // State to hold the selected value
  const [restuarnt, setrestuarnt] = useState([]);

  useEffect(() => {
    const flag = "1";
    let call_id = "0";
    master_data_get(formatDate(startDate), formatDate(endDate), flag, call_id);
  }, []);
  // console.log('restuarnt',restuarnt)
  // Format Date object to 'YYYY-MM-DD' string format
  const formatDate = (date) => {
    if (!date) return "";
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const handleShowAll = () => {
    setfilteredData();
    setSearchText("");
    // setCurrentPage(1);
  };

  const search_data = () => {
    const flag = "2";
    const call_id = "0";
    master_data_get(formatDate(startDate), formatDate(endDate), flag, call_id);
  };

  const master_data_get = async (start_date, end_date) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("start_date", start_date);
    fd.append("end_date", end_date);
    await server_post_data(restaurant_subscriptions, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          setfilteredData(Response.data.message.classified_restaurants);
          seteditStaffData(Response.data.message.classified_restaurants);
          setrestuarnt(Response.data.message.reservation_list);
        }

        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        console.log(error);
        setshowLoaderAdmin(false);
      });
  };

  const handleSearch = (event) => {
    const searchValue = event.target.value;
    setSearchFilter(searchValue);

    // Filter table data based on search value
    const filteredDatashow = editStaffData.filter((row) => {
      return Object.values(row).some((value) => {
        if (value !== null && value !== undefined) {
          // Add null check here
          return (
            typeof value === "string"
              ? value.toLowerCase()
              : value.toString().toLowerCase()
          ).includes(searchValue.toLowerCase());
        }
        return false;
      });
    });

    setfilteredData(filteredDatashow);
  };
  const [showModal, setShowModal] = useState(false);
  const [selectedGuestIndexData, setSelectedGuestIndexData] = useState(null);

  const openModal = (guestData) => {
    setSelectedData(guestData);
    setShowModal(true);
  };

  const [showEditModal, setShowEditModal] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);

  const openEditModal = (data) => {
    setShowEditModal(true);
    setSelectedGuestIndexData(filteredData[data]);
  };
  const openShowModal = () => {
    setShowAddModal(true);
  };

  const closeEditModal = () => {
    setShowEditModal(false);
    setShowAddModal(false);
  };

  const closeModal = () => {
    setShowModal(false);
  };
  // Save auto
  const [SelectedData, setSelectedData] = useState({
    restaurant_id: "",
    order_id: "",
    transaction_id: "",
    subscription_amount: "",
    subscription_period: "",
    subscription_start_date: computeTodayDate(), // ← NAYA: Default today
    subscription_end_date: "", // ← Auto calculate hoga
  });
  const [isFormValid, setIsFormValid] = useState(false);
  // Add this function inside component
  const calculateEndDate = (startDate, days) => {
    if (!startDate || !days) return "";
    const start = new Date(startDate);
    const end = new Date(start);
    end.setDate(start.getDate() + parseInt(days));
    return end.toISOString().split("T")[0]; // YYYY-MM-DD format
  };
  useEffect(() => {
    if (
      SelectedData.subscription_start_date &&
      SelectedData.subscription_period
    ) {
      const endDate = calculateEndDate(
        SelectedData.subscription_start_date,
        SelectedData.subscription_period
      );
      setSelectedData((prev) => ({ ...prev, subscription_end_date: endDate }));
    }
  }, [SelectedData.subscription_start_date, SelectedData.subscription_period]);

  // 🔁 useEffect to validate form
  // useEffect(() => {
  //   const { order_id, transaction_id, subscription_amount, subscription_period, restaurant_id } = SelectedData;
  //   const isValid =
  //     order_id.trim() !== "" &&
  //     transaction_id.trim() !== "" &&
  //     subscription_amount.trim() !== "" &&
  //     subscription_period.trim() !== "" &&
  //     restaurant_id !== "";

  //   setIsFormValid(isValid);
  // }, [SelectedData]);

  useEffect(() => {
    const {
      restaurant_id,
      order_id,
      transaction_id,
      subscription_amount,
      subscription_period,
      subscription_start_date,
    } = SelectedData;

    const isValid =
      String(restaurant_id).trim() !== "" &&
      String(order_id).trim() !== "" &&
      String(transaction_id).trim() !== "" &&
      String(subscription_amount).trim() !== "" &&
      String(subscription_period).trim() !== "" &&
      String(subscription_start_date).trim() !== "";

    setIsFormValid(isValid);
  }, [SelectedData]);

  const handleSaveChanges = async (form_data, url_for_save) => {
    if (selectedGuestIndexData && selectedGuestIndexData.main_id) {
      setshowLoaderAdmin(true);
      let fd_from = combiled_form_data(form_data, null);
      // let fd_from = form_data;

      // Append the main_id to the formData
      fd_from.append("main_id", selectedGuestIndexData.main_id);

      await server_post_data(url_for_save, fd_from) // Replace with your actual API endpoint
        .then((Response) => {
          setshowLoaderAdmin(false);
          // console.log(Response.data);
          if (Response.data.error) {
            handleError(Response.data.message);
          } else {
            // console.log("go inside")
            closeEditModal(); // Close the modal after saving
            handleSuccess(Response.data.message);
            master_data_get(
              formatDate(startDate),
              formatDate(endDate),
              "1",
              "0"
            ); // Refresh the data
          }
        })
        .catch((error) => {
          console.log(error);
          handleError("network");
          setshowLoaderAdmin(false);
        });
    } else {
      console.log("No Main ID found");
    }
  };

  const handleSaveChanges_add = async (form_data, url_for_save) => {
    setshowLoaderAdmin(true);
    // let fd_from = combiled_form_data(form_data, null)
    // ;

    let fd_from = new FormData();
    fd_from.append("restaurant_id", SelectedData.restaurant_id);
    fd_from.append("order_id", SelectedData.order_id);
    fd_from.append("transaction_id", SelectedData.transaction_id);
    fd_from.append("subscription_amount", SelectedData.subscription_amount);
    fd_from.append("subscription_period", SelectedData.subscription_period);
    fd_from.append(
      "subscription_start_date",
      SelectedData.subscription_start_date
    );
    fd_from.append(
      "subscription_end_date",
      SelectedData.subscription_end_date || ""
    ); // ← Yeh add karo
    await server_post_data(url_for_save, fd_from)
      .then((Response) => {
        setshowLoaderAdmin(false);
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          handleSuccess(Response.data.message);
          closeEditModal(); // Close the modal after saving
          master_data_get(formatDate(startDate), formatDate(endDate), "1", "0"); // Refresh the data
        }
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };
  // Handle input change for all fields
  const handleInputChange = (key, value) => {
    const updatedData = { ...SelectedData, [key]: value };
    setSelectedData(updatedData);
  };

  const handleChange1 = (selectedOption) => {
    const updatedData = {
      ...SelectedData,
      restaurant_id: selectedOption?.value,
    };
    setSelectedData(updatedData);
  };

  const handleNumbersChange = (e) => {
    const val = e.target.value.replace(/\D/, "");
    handleInputChange(e.target.name, val);
  };
  const handleChange11 = () => {};
  // Create a max date for date picker (today)
  const today = new Date();

  // Custom styles for the date picker to match your design
  const datePickerCustomStyles = {
    datePickerContainer: {
      position: "relative",
      width: "100%",
    },
    datePickerInput: {
      width: "100%",
      padding: "0.375rem 0.75rem",
      fontSize: "1rem",
      lineHeight: "1.5",
      color: "#495057",
      backgroundColor: "#fff",
      backgroundClip: "padding-box",
      border: "1px solid #ced4da",
      borderRadius: "0.25rem",
      transition:
        "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
    },
  };

  //pagination

  const [currentPage, setCurrentPage] = useState(1);
  const entriesPerPage = 5;

  const totalPages = Math.ceil(filteredData?.length / entriesPerPage);
  const handlePageChange = (pageNumber, e) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setCurrentPage(pageNumber);
  };

  const currentData = filteredData?.slice(
    (currentPage - 1) * entriesPerPage,
    currentPage * entriesPerPage
  );

  return (
    <>
      {showLoaderAdmin && <Loader />}{" "}
      <div className="dashboard" style={{ overflow: "hidden" }}>
        <div className="dashboard_container">
          <div className="page_content">
            <div className="page_content_container">
              <Header />
              <div className="pageCntn_head">
                <div className="pageNameDiv">
                  <p>Subscription Management</p>
                  {/* <p>{GuestManagementPageText.Guest_Management}</p> */}
                  <img src={GreyArrow} alt="Uprestro Dashboard" />
                </div>
                <div className="bottomAlgin " style={{ margin: "0 3rem" }}>
                  <button
                    type="button"
                    className="btnAddStaff add_staff"
                    onClick={openShowModal}
                  >
                    Add Subscription
                  </button>
                </div>
              </div>

              <div className="page_body">
                <div className="viewStaff">
                  <div className="viewStaff_head">
                    {/* <div className="row m-0">
                      <div className="col-lg-2 col-sm-4 bottomAlgin">
                        <label className="labelView">
                          {GuestManagementPageText.Start_Date}
                        </label>
                        <div className="person__calenderFrame_image image_icon_position1" style={datePickerCustomStyles.datePickerContainer}>
                          <DatePicker
                            selected={startDate}
                            onChange={(date) => setStartDate(date)}
                            maxDate={today}
                            className="form-control input_field_custom4"
                            dateFormat="yyyy-MM-dd"
                            placeholderText={GuestManagementPageText.D_O_B}
                            style={datePickerCustomStyles.datePickerInput}
                          />
                        </div>
                      </div>
                      <div className="col-lg-2 col-sm-4 bottomAlgin">
                        <label className="labelView">
                          {GuestManagementPageText.End_Date}
                        </label>
                        <div className="person__calenderFrame_image image_icon_position1" style={datePickerCustomStyles.datePickerContainer}>
                          <DatePicker
                            selected={endDate}
                            onChange={(date) => setEndDate(date)}
                            maxDate={today}
                            className="form-control input_field_custom4"
                            dateFormat="yyyy-MM-dd"
                            placeholderText={GuestManagementPageText.D_O_B}
                            style={datePickerCustomStyles.datePickerInput}
                          />
                        </div>
                      </div>

                      <div className="col-lg-2 mb-2 col-sm-1 bottomAlgin">
                        <div
                          className="inputDiv2"
                          style={{
                            boxShadow: "none",
                            padding: 0,
                            backgroundColor: "transparent",
                          }}
                        >
                          <button
                            type="button"
                            className="btnSearch"
                            onClick={() => search_data()}
                            style={{
                              height: "40px",
                              position: "static",
                              right: "0",
                              top: "0",
                            }}
                          >
                            {GuestManagementPageText.Search_text}
                          </button>
                        </div>
                      </div>

                      <div
                        className="col-xl-3 col-md-4 mt-4"
                        style={{ marginLeft: "auto", marginRight: "0" }}
                      >
                        <div className="inputDiv2">
                          <label
                            className="labelPointer"
                            htmlFor="selectFilter"
                          >
                            <img src={FilterIcon} alt="Uprestro Dashboard" />
                          </label>
                          <input
                            type="text"
                            placeholder={GuestManagementPageText.Guest_Filter}
                            value={searchfilter}
                            onInput={handleIaphabetnumberChange}
                            onChange={handleSearch}
                          />
                        </div>
                      </div>
                    </div> */}

                    <div className="crm-filters-section">
                      <div className="crm-filter-group filter_section">
                        <label>Filter</label>
                        <div className="date-input">
                          <select
                            value={filterOption}
                            onChange={(e) => setFilterOption(e.target.value)}
                            style={{
                              width: "100%",
                              padding: "0.5rem",
                              borderRadius: "4px",
                            }}
                            className="form-select"
                          >
                            <option value="" disabled>
                              Select Option
                            </option>
                            <option value="today">Today</option>
                            <option value="this_week">This Week</option>
                            <option value="this_month">This Month</option>
                            <option value="this_year">This Year</option>
                            <option value="custom">Custom</option>
                          </select>
                        </div>
                      </div>
                      {filterOption === "custom" && (
                        <>
                          <div className="crm-filter-group">
                            <label className="">
                              {" "}
                              {GuestManagementPageText.Start_Date}
                            </label>
                            <div className="crm-date-input">
                              <DatePicker
                                selected={startDate}
                                onChange={(date) => setStartDate(date)}
                                maxDate={today}
                                // showYearDropdown
                                // showMonthDropdown
                                // dropdownMode="select"
                                // className="form-control input_field_custom4"
                                dateFormat="yyyy-MM-dd"
                                placeholderText={GuestManagementPageText.D_O_B}
                                style={datePickerCustomStyles.datePickerInput}
                                className="crm-form-control"
                              />
                              <Calendar className="crm-date-icon" size={16} />
                            </div>
                          </div>
                          <div className="crm-form-group1">
                            <label className="mb-2">End Date</label>
                            <div className="crm-date-input">
                              <DatePicker
                                selected={endDate}
                                onChange={(date) => setEndDate(date)}
                                maxDate={today}
                                className="crm-form-control"
                                dateFormat="yyyy-MM-dd"
                                placeholderText={GuestManagementPageText.D_O_B}
                                style={datePickerCustomStyles.datePickerInput}
                              />
                              <Calendar className="crm-date-icon" size={16} />
                            </div>
                          </div>
                        </>
                      )}

                      <div className="crm-search-group">
                        <div className="crm-search-input-container">
                          <Search size={16} className="crm-search-icon" />
                          <input
                            type="text"
                            placeholder="Search"
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                            className="crm-search-input"
                          />
                        </div>
                      </div>

                      <div className="d-flex gap-2 align-items-end">
                        <button
                          className="crm-search-btn"
                          onClick={() => search_data()}
                        >
                          {GuestManagementPageText.Search_text}
                        </button>
                        {/* <button className="crm-show-all-btn">Show All</button> */}
                      </div>
                    </div>
                  </div>

                  <div className="viewGuest_table ">
                    <div className="viewGuest_table_container ">
                      <div className="row m-0">
                        <div className="col-md-12 table-responsive stickyTableheigh335">
                          <table className="table">
                            <thead className="stickyHeaderClss">
                              <tr>
                                <th scope="col">
                                  <div className="theadStyle imgThead">
                                    <span>S.No.</span>
                                  </div>
                                </th>
                                <th scope="col">
                                  <div className="theadStyle imgThead">
                                    {/* <img src={GuestIcon} alt="Dashboard" /> */}
                                    <span>Restaurant Name</span>
                                  </div>
                                </th>
                                {/* <th scope="col">
                                <div className="theadStyle">Location</div>
                              </th> */}
                                <th scope="col">
                                  <div className="theadStyle">
                                    Subscribed Since
                                  </div>
                                </th>
                                <th scope="col">
                                  <div className="theadStyle">Tenure</div>
                                </th>
                                {/* <th scope="col">
                                  <div className="theadStyle">
                                    Next Renewal Date
                                  </div>
                                </th> */}
                                <th scope="col">
                                  <div className="theadStyle">View Details</div>
                                </th>
                                <th scope="col">
                                  <div className="theadStyle"></div>
                                </th>
                              </tr>
                            </thead>
                            <tbody className="tboday">
                              {/* {console.log(filteredData)} */}
                              {currentData &&
                                currentData.length > 0 &&
                                currentData.map((option, index) => (
                                  // {[...filteredData].reverse().map((option, index) => (
                                  <React.Fragment key={index}>
                                    <tr className="tableRow tbodyStyle">
                                      <td className="th1 tabledata">
                                        <div className="guest_incenter borderLeftRadius">
                                          {(currentPage - 1) * entriesPerPage +
                                            index +
                                            1}
                                        </div>
                                      </td>
                                      <td className="th1 tabledata">
                                        <div className="guest_incenter borderLeftRadius">
                                          {option.restaurant_name}
                                        </div>
                                      </td>
                                      {/* <td className="tabledata">
                                    <div className="guest_incenter shadowOnlyBottom">
                                      {`${option.restaurant_city || ""}, ${
                                        option.restaurant_state || ""
                                      }, ${
                                        option.restaurant_country || ""
                                      }`.replace(/(^[,\s]+)|([,\s]+$)/g, "") ||
                                        "N/A"}
                                    </div>
                                  </td> */}
                                      <td className="tabledata">
                                        <div className="guest_incenter shadowOnlyBottom">
                                          {option.subscription_start_date
                                            ? `${option.subscription_start_date}`
                                            : // ? `${option.subscription_start_date} (${option.subscription_duration_days} days)`
                                              "N/A"}
                                        </div>
                                      </td>
                                      <td className="tabledata">
                                        <div className="guest_incenter shadowOnlyBottom">
                                          {option.subscription_period
                                            ? `${option.subscription_period} days`
                                            : "N/A"}
                                        </div>
                                      </td>
                                      {/* <td className="tabledata">
                                        <div className="guest_incenter shadowOnlyBottom">
                                          {option.subscription_next_renewal_date ||
                                            "N/A"}
                                        </div>
                                      </td> */}
                                      <td className="tabledata d-flex align-items-center mb-0 m-1">
                                        <div className="img-icons">
                                          <button
                                            type="button"
                                            style={{
                                              backgroundColor: "#666666",
                                              borderRadius: "1rem",
                                              border: "none",
                                              padding: "0.2rem 0.4rem",
                                            }}
                                            onClick={() =>
                                              openModal(option, index)
                                            }
                                          >
                                            <p
                                              style={{
                                                margin: "0 2rem",
                                                color: "#ffffff",
                                              }}
                                            >
                                              Details
                                            </p>
                                          </button>
                                          &nbsp; &nbsp;
                                          {/* <img
                                            onClick={() => openEditModal(index)}
                                            className=""
                                            src={update}
                                            alt="update"
                                            style={{ cursor: "pointer" }}
                                          /> */}
                                        </div>
                                      </td>
                                    </tr>
                                    <tr
                                      key={`spacer-${index}`}
                                      style={{ height: "1rem" }}
                                    ></tr>
                                  </React.Fragment>
                                ))}
                              {filteredData.length === 0 && (
                                <>
                                  <tr>
                                    <td
                                      colSpan={6}
                                      className="text_align_center"
                                    >
                                      No Results Found
                                    </td>
                                  </tr>
                                </>
                              )}
                            </tbody>
                          </table>
                        </div>
                        <div className="pagination-container">
                          <Pagination>
                            <Pagination.First
                              onClick={() => handlePageChange(1)}
                              disabled={currentPage === 1}
                            />
                            <Pagination.Prev
                              onClick={() => handlePageChange(currentPage - 1)}
                              disabled={currentPage === 1}
                            />

                            {[...Array(totalPages)].map((_, index) => (
                              <Pagination.Item
                                key={index + 1}
                                active={index + 1 === currentPage}
                                onClick={() => handlePageChange(index + 1)}
                              >
                                {index + 1}
                              </Pagination.Item>
                            ))}

                            <Pagination.Next
                              onClick={() => handlePageChange(currentPage + 1)}
                              disabled={currentPage === totalPages}
                            />
                            <Pagination.Last
                              onClick={() => handlePageChange(totalPages)}
                              disabled={currentPage === totalPages}
                            />
                          </Pagination>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Rest of your modal code remains the same */}
        <Modal show={showModal} onHide={closeModal} centered backdrop="static">
          <Modal.Body className="modal_body justify-content-start">
            <div className="success_img bodyText">
              <div className="row m-0">
                <div className="col-5">
                  <p style={{ fontWeight: "400", letterSpacing: "0" }}>
                    {"Restaurant Name :"}
                  </p>
                </div>
                <div className="col-7">
                  <p>{SelectedData.restaurant_name}</p>
                </div>
              </div>
              <div className="row m-0">
                <div className="col-5">
                  <p style={{ fontWeight: "400", letterSpacing: "0" }}>
                    {"City :"}
                  </p>
                </div>
                <div className="col-7">
                  <p>{SelectedData.restaurant_city}</p>
                </div>
              </div>
              <div className="row m-0">
                <div className="col-5">
                  <p style={{ fontWeight: "400", letterSpacing: "0" }}>
                    {"State :"}
                  </p>
                </div>
                <div className="col-7">
                  <p>{SelectedData.restaurant_state}</p>
                </div>
              </div>
              <div className="row m-0">
                <div className="col-5">
                  <p style={{ fontWeight: "400", letterSpacing: "0" }}>
                    {"Country :"}
                  </p>
                </div>
                <div className="col-7">
                  <p>{SelectedData.restaurant_country}</p>
                </div>
              </div>
              <div className="row m-0">
                <div className="col-5">
                  <p style={{ fontWeight: "400", letterSpacing: "0" }}>
                    {"Subscribed Since :"}
                  </p>
                </div>
                <div className="col-7">
                  <p>
                    {" "}
                    {SelectedData.subscription_start_date}{" "}
                    {SelectedData.subscription_duration_days} {"Days"}
                  </p>
                </div>
              </div>
              {/* <div className="row m-0">
                <div className="col-5">
                  <p style={{ fontWeight: "400", letterSpacing: "0" }}>
                    {"Latest Renewal Date :"}
                  </p>
                </div>
                <div className="col-7">
                  <p>{SelectedData.subscription_last_renewal_date}</p>
                </div>
              </div> */}
              <div className="row m-0">
                <div className="col-5">
                  <p style={{ fontWeight: "400", letterSpacing: "0" }}>
                    {"Tenure :"}
                  </p>
                </div>
                <div className="col-7">
                  <p>{SelectedData.subscription_period}</p>
                </div>
              </div>
              {/* <div className="row m-0">
                <div className="col-5">
                  <p style={{ fontWeight: "400", letterSpacing: "0" }}>
                    {"Next Due Date :"}
                  </p>
                </div>
                <div className="col-7">
                  <p>{SelectedData.subscription_next_renewal_date}</p>
                </div>
              </div> */}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button className="logoutNoBtn hoverRed" onClick={closeModal}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={showEditModal}
          onHide={closeEditModal}
          centered
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Edit Subscription (
              {selectedGuestIndexData && selectedGuestIndexData.restaurant_name}
              )
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedGuestIndexData && (
              <form id="editSubsData">
                <div className="form-group">
                  <label
                    style={{ fontWeight: "500" }}
                    htmlFor="subscription_Last_renewal_date"
                  >
                    Latest Subscription Date
                  </label>
                  <input
                    style={{ marginBottom: "0.5rem" }}
                    type="date"
                    className="form-control"
                    id="subscription_Last_renewal_date"
                    name="subscription_Last_renewal_date"
                    defaultValue={
                      selectedGuestIndexData.subscription_last_renewal_date ||
                      ""
                    }
                    onChange={(e) => {
                      setSelectedData({
                        ...SelectedData,
                        restaurant_name: e.target.value,
                      });
                    }}
                  />
                </div>
                <div className="form-group">
                  <label
                    style={{ fontWeight: "500" }}
                    htmlFor="subscription_renewal_date"
                  >
                    Next Due Date
                  </label>
                  <input
                    style={{ marginBottom: "0.5rem" }}
                    type="date"
                    className="form-control"
                    id="subscription_renewal_date"
                    name="subscription_renewal_date"
                    defaultValue={
                      selectedGuestIndexData.subscription_next_renewal_date ||
                      ""
                    }
                    onChange={(e) => {
                      setSelectedData({
                        ...SelectedData,
                        restaurant_name: e.target.value,
                      });
                    }}
                  />
                </div>
                <div className="form-group">
                  <label
                    style={{ fontWeight: "500" }}
                    htmlFor="subscription_amount"
                  >
                    Subscription Amount
                  </label>
                  <input
                    style={{ marginBottom: "0.5rem" }}
                    type="text"
                    className="form-control"
                    onInput={handleNumbersChange}
                    id="subscription_amount"
                    name="subscription_amount"
                    // placeholder="enter amount"
                    defaultValue={
                      selectedGuestIndexData.subscription_amount || ""
                    }
                    onChange={(e) => {
                      setSelectedData({
                        ...SelectedData,
                        restaurant_name: e.target.value,
                      });
                    }}
                  />
                </div>
                <div className="form-group">
                  <label
                    style={{ fontWeight: "500" }}
                    htmlFor="subscription_period"
                  >
                    Subscription Period (In Day's)
                  </label>
                  <input
                    style={{ marginBottom: "0.5rem" }}
                    type="text"
                    className="form-control"
                    id="subscription_period"
                    onInput={handleNumbersChange}
                    name="subscription_period"
                    // placeholder="No of Days"
                    defaultValue={
                      selectedGuestIndexData.subscription_period || ""
                    }
                    onChange={(e) => {
                      setSelectedData({
                        ...SelectedData,
                        restaurant_name: e.target.value,
                      });
                    }}
                  />
                </div>
              </form>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={closeEditModal}>
              Close
            </Button>
            <Button
              variant="primary"
              className="logoutNoBtn"
              onClick={() =>
                handleSaveChanges("editSubsData", save_restaurant_subs)
              }
            >
              Save Changes
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={showAddModal}
          onHide={closeEditModal}
          centered
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title>Add Subscription</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form id="AddSubsData">
              <div className="form-group">
                <label style={{ fontWeight: "500" }} htmlFor="restaurantName">
                  Restaurant Name
                </label>
                <Select
                  id="select_category"
                  name="admin_category"
                  className="input_field_custom1_add_restro"
                  placeholder="Select restaurant"
                  options={
                    restuarnt?.length > 0 &&
                    restuarnt.map((option) => ({
                      value: option.primary_id,
                      label: `${option.restaurant_name} (${option.restaurant_city})`,
                    }))
                  }
                  onChange={handleChange1}
                  style={{ marginBottom: "0.5rem" }}
                />
              </div>

              <div className="form-group">
                <label style={{ fontWeight: "500" }} htmlFor="order_id">
                  Order ID
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="order_id"
                  name="order_id"
                  onChange={(e) =>
                    handleInputChange("order_id", e.target.value)
                  }
                  style={{ marginBottom: "0.5rem" }}
                />
              </div>

              <div className="form-group">
                <label style={{ fontWeight: "500" }} htmlFor="transaction_id">
                  Transaction ID
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="transaction_id"
                  name="transaction_id"
                  onChange={(e) =>
                    handleInputChange("transaction_id", e.target.value)
                  }
                  style={{ marginBottom: "0.5rem" }}
                />
              </div>

              <div className="form-group">
                <label
                  style={{ fontWeight: "500" }}
                  htmlFor="subscription_amount"
                >
                  Subscription Amount
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="subscription_amount"
                  name="subscription_amount"
                  maxLength={5}
                  onInput={handleNumbersChange}
                  onChange={(e) =>
                    handleInputChange("subscription_amount", e.target.value)
                  }
                  style={{ marginBottom: "0.5rem" }}
                />
              </div>

              <div className="form-group">
                <label
                  style={{ fontWeight: "500" }}
                  htmlFor="subscription_start_date"
                >
                  Subscription Start Date
                </label>
                <input
                  type="date"
                  className="form-control"
                  id="subscription_start_date"
                  name="subscription_start_date"
                  value={SelectedData.subscription_start_date || ""}
                  min={computeTodayDate()}
                  onChange={(e) =>
                    handleInputChange("subscription_start_date", e.target.value)
                  }
                  style={{ marginBottom: "0.5rem" }}
                />
              </div>

              <div className="form-group">
                <label
                  style={{ fontWeight: "500" }}
                  htmlFor="subscription_period"
                >
                  Subscription Period (Days)
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="subscription_period"
                  name="subscription_period"
                  maxLength={4}
                  placeholder="e.g. 30, 90, 365"
                  onInput={handleNumbersChange}
                  onChange={(e) =>
                    handleInputChange("subscription_period", e.target.value)
                  }
                  style={{ marginBottom: "0.5rem" }}
                />
              </div>

              {/* ← Yeh Preview dikhayega */}
              {SelectedData.subscription_end_date && (
                <div className="form-group">
                  <label style={{ fontWeight: "600", color: "#28a745" }}>
                    Subscription Valid Till (Auto Calculated)
                  </label>
                  <div
                    className="form-control"
                    style={{
                      backgroundColor: "#d4edda",
                      color: "#155724",
                      fontWeight: "bold",
                      border: "1px solid #c3e6cb",
                    }}
                  >
                    {SelectedData.subscription_end_date}
                  </div>
                  <small style={{ color: "#28a745" }}>
                    End date calculated as Start Date +{" "}
                    {SelectedData.subscription_period} days
                  </small>
                </div>
              )}
            </form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={closeEditModal}>
              Close
            </Button>
            <Button
              variant="primary"
              className="logoutNoBtn"
              style={{
                opacity: isFormValid ? 1 : 0.5,
                backgroundColor: isFormValid ? "var(--primary-color)" : "",
                pointerEvents: isFormValid ? "auto" : "none",
                color: isFormValid ? "white" : "",
              }}
              onClick={() =>
                handleSaveChanges_add(
                  "AddSubsData",
                  save_restaurant_subs
                )
              }
            >
              Save
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
}

export default SubscriptionManagement;
